import React from "react";
import { motion } from "framer-motion";
import styles from "./DashboardTopBarAdmin.module.css";

const DashboardTopBarAdmin = ({ title, icon, description, children }) => {
   // Framer Motion varianten
   const containerVariants = {
      hidden: { opacity: 0, y: -20 },
      visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
   };

   const iconVariants = {
      hidden: { scale: 0.8, opacity: 0 },
      visible: { scale: 1, opacity: 1, transition: { duration: 0.4, ease: "easeOut" } },
   };

   const textVariants = {
      hidden: { opacity: 0, y: 10 },
      visible: { opacity: 1, y: 0, transition: { duration: 0.6, delay: 0.2 } },
   };

   return (
      <motion.nav
         className={`py-30 px-30 ${styles.nav}`}
         initial="hidden"
         animate="visible"
         variants={containerVariants}
      >
         <div className="g-60-1fr">
            <motion.div className={styles.icon} variants={iconVariants}>
               <img src={icon} alt={title} />
            </motion.div>
            <motion.div className="g-5" variants={textVariants}>
               <h1>{title}</h1>
               <p className="c-g">{description}</p>
            </motion.div>
         </div>

         <motion.div className="flex-2" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5, delay: 0.3 }}>
            {children}
         </motion.div>
      </motion.nav>
   );
};

export default DashboardTopBarAdmin;
